
import { Component, Vue, Prop } from "vue-property-decorator";
import { getTongueResult } from "@/api/open";



@Component({ name: 'open-tongue-components-collectStep2',
    components: {
    }
})
export default class OpenTongueCollectStep2 extends Vue {
    @Prop({ default: "" }) reportId: string;

    timer = null;
    needRestartTimer = false;

    // keep-alive 缓存后 destroyed 不会触发，改用 activated/deactivated
    activated() {
        // 回到页面时，如果之前有轮询在跑，重新启动
        if (this.needRestartTimer) {
            this.startCheckResult();
        }
    }

    deactivated() {
        // 离开页面时，记录轮询状态并清除定时器
        if (this.timer) {
            this.needRestartTimer = true;
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    checkResult() {
        console.log("checkResult", this.reportId);
        if (!this.reportId) {
            this.$confirm("未检测到舌面信息，请重新扫码检测", "提示", {
                confirmButtonText: "确定",
                type: "warning"
            }).finally(() => {
                clearInterval(this.timer);
                this.$emit("restart");
            });
            return;
        }
        getTongueResult({ id: this.reportId }).then((res: any) => {
            console.log("res", res)
            const {code, data } = res.data;
            if (code) {
                switch (code) {
                    case "0000":
                        clearInterval(this.timer);
                        this.$emit("goResult");
                    return;
                        case "201":
                        break;
                    default:
                        clearInterval(this.timer);
                        this.$emit("goResultError");
                        return;
                }
            }
        });
    }

    startCheckResult() {
        this.timer = setInterval(() => {
            this.checkResult();
        }, 5000);
    }
}
